import { StatsigClient } from '@statsig/js-client';
import TagManager, { TagManagerArgs, DataLayerArgs } from 'react-gtm-module';

import {
  TAG_MANAGER_ID,
  PROJECT_EVENT_TAG,
  EVENT_SEPARATOR,
  RESET_VARIABLES,
  TAG_MANAGER_ENV,
  TAG_MANAGER_AUTH
} from '../../constants/tagManager';
import { GenericObject } from '../../types/genericTypes';

export class TagManagerService {
  gtmId = TAG_MANAGER_ID;
  env = TAG_MANAGER_ENV;
  auth = TAG_MANAGER_AUTH;

  public initialize() {
    const tagManagerArgs: TagManagerArgs = {
      gtmId: this.gtmId,
      auth: this.auth,
      preview: this.env
    };
    TagManager.initialize(tagManagerArgs);
  }

  public pushEvent(action: string, description: string, additionalParams: GenericObject = {}) {
    const event = [PROJECT_EVENT_TAG, action, description].join(EVENT_SEPARATOR);
    const dataLayerArgs: DataLayerArgs = {
      dataLayer: {
        event,
        ...additionalParams
      }
    };
    TagManager.dataLayer(dataLayerArgs);
    if (Object.keys(additionalParams).length !== 0) {
      this.resetVariables(additionalParams);
    }
  }

  public pushAllEvents(action: string, description: string, additionalParams: GenericObject = {}) {
    this.pushEvent(action, description, additionalParams);
    StatsigClient.instance().logEvent(description);
  }

  public resetVariables(additionalParams: GenericObject) {
    const event = [PROJECT_EVENT_TAG, RESET_VARIABLES].join(EVENT_SEPARATOR);
    const clearDataDic: GenericObject = {};
    Object.keys(additionalParams).forEach((key) => {
      clearDataDic[key] = '';
    });
    const dataLayerArgs: DataLayerArgs = {
      dataLayer: {
        event,
        ...clearDataDic
      }
    };
    TagManager.dataLayer(dataLayerArgs);
  }
}

export default new TagManagerService();
